import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useGuidesListingStore, { setGuidesSearch } from 'layout/Listing/variants/guides/store';

const useGuidesFilterSearchParam = () => {
  const activeSearch = useGuidesListingStore(state => state.search);
  const { push } = useRouter();

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    const search = params?.get('s');

    search && search !== '' && setGuidesSearch(search);
  }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    activeSearch ? params.set('s', activeSearch) : params.delete('s');

    const newUrl = url.toString();

    push(newUrl, newUrl, { shallow: true, scroll: false });
  }, [activeSearch]);
};

export default useGuidesFilterSearchParam;
